import { render, staticRenderFns } from "./FilterStudentsDialog.vue?vue&type=template&id=554c6d45&scoped=true"
import script from "./FilterStudentsDialog.vue?vue&type=script&lang=js"
export * from "./FilterStudentsDialog.vue?vue&type=script&lang=js"
import style0 from "./FilterStudentsDialog.vue?vue&type=style&index=0&id=554c6d45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554c6d45",
  null
  
)

export default component.exports